import { useState } from 'react'
import { RefreshCw } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { FiltrosReporteOdf } from '../types'
import { FiltrosBar } from '../components/FiltrosBar'
import { OverviewTab } from '../components/OverviewTab'
import { MedicosTab } from '../components/MedicosTab'
import { ContenidoTab } from '../components/ContenidoTab'

const FILTROS_INICIALES: FiltrosReporteOdf = {}

export function ReporteAnalyticsOdfPage() {
  const [filtros, setFiltros] = useState<FiltrosReporteOdf>(FILTROS_INICIALES)

  return (
    <div className="p-4 space-y-5">
      {/* Header */}
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <h1 className="text-xl font-bold">ODF Expertos · Analytics</h1>
        <span className="flex items-center gap-1 text-xs text-muted-foreground">
          <RefreshCw className="h-3 w-3" /> datos en vivo
        </span>
      </div>

      {/* Filtros */}
      <FiltrosBar filtros={filtros} onChange={setFiltros} />

      {/* Secciones */}
      <Tabs defaultValue="overview" className="space-y-4">
        <TabsList>
          <TabsTrigger value="overview">Resumen</TabsTrigger>
          <TabsTrigger value="medicos">Médicos</TabsTrigger>
          <TabsTrigger value="contenido">Contenido</TabsTrigger>
        </TabsList>
        <TabsContent value="overview">
          <OverviewTab filtros={filtros} />
        </TabsContent>
        <TabsContent value="medicos">
          <MedicosTab filtros={filtros} />
        </TabsContent>
        <TabsContent value="contenido">
          <ContenidoTab filtros={filtros} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
